<template>
  <div class="ky-footer">
    <div class="footer-inner">
      <div class="footer-top">
        <div class="footer-logo">
          <a href="https://www.kylinos.cn/" target="_blank">
            <img src="@/assets/logo.png" alt="麒麟软件" />
          </a>
        </div>
        <div class="footer-main">
          <ul class="direct-links">
            <li class="direct-links-item">
              <a href="https://www.kylinos.cn/support/trial/" target="_blank">试用申请</a>
            </li>
            <li class="direct-links-item">
              <a href="https://kb.kylinos.cn/zsk" target="_blank">知识库</a>
            </li>
            <li class="direct-links-item">
              <a href="https://developer.kylinos.cn/" target="_blank">开发者</a>
            </li>
            <li class="direct-links-item">
              <a href="https://www.kylinos.cn/compliances/index.html" target="_blank">出口合规</a>
            </li>
            <li class="direct-links-item">
              <a href="https://www.openkylin.top/" target="_blank">openKylin社区</a>
            </li>
            <li class="direct-links-item">
              <a href="https://www.kylinos.cn/about/contact/index.html" target="_blank">联系我们</a>
            </li>
          </ul>
          <div class="connection-list">
            <div class="footer-connection-item">
              <svg class="icon-phone" viewBox="0 0 16.077 16.077" width="16" height="16" fill="currentColor">
                <path d="M1.113,1.792C0.051,2.854-0.432,4.502,0.484,5.936C1.241,7.121,2.571,8.848,4.9,11.177C7.23,13.507,8.957,14.836,10.142,15.593C11.576,16.51,13.223,16.027,14.286,14.964C14.286,14.964,15.418,13.832,15.418,13.832C16.297,12.953,16.297,11.528,15.418,10.65C15.418,10.65,13.933,9.164,13.933,9.164C13.272,8.503,12.249,8.367,11.438,8.833C10.956,9.11,10.348,9.029,9.955,8.636C9.955,8.636,7.441,6.122,7.441,6.122C7.048,5.729,6.967,5.121,7.244,4.64C7.71,3.829,7.575,2.806,6.913,2.145C6.913,2.145,5.428,0.659,5.428,0.659C4.549,-0.22,3.125,-0.22,2.246,0.659C2.246,0.659,1.113,1.792,1.113,1.792ZM1.748,5.128C1.313,4.447,1.461,3.565,2.174,2.852C2.174,2.852,3.306,1.72,3.306,1.72C3.599,1.427,4.074,1.427,4.367,1.72C4.367,1.72,5.853,3.205,5.853,3.205C6.035,3.387,6.072,3.669,5.944,3.892C5.329,4.962,5.508,6.31,6.38,7.183C6.38,7.183,8.895,9.697,8.895,9.697C9.767,10.569,11.116,10.748,12.185,10.134C12.409,10.005,12.69,10.043,12.872,10.225C12.872,10.225,14.358,11.71,14.358,11.71C14.651,12.003,14.651,12.478,14.358,12.771C14.358,12.771,13.225,13.904,13.225,13.904C12.513,14.616,11.63,14.765,10.949,14.329C9.876,13.643,8.232,12.388,5.961,10.117C3.689,7.845,2.434,6.202,1.748,5.128ZM9.874,0.879C9.874,0.464,10.21,0.129,10.624,0.129C13.524,0.129,15.874,2.479,15.874,5.379C15.874,5.793,15.539,6.129,15.124,6.129C14.71,6.129,14.374,5.793,14.374,5.379C14.374,3.308,12.696,1.629,10.624,1.629C10.21,1.629,9.874,1.293,9.874,0.879ZM9.874,3.879C9.874,3.464,10.21,3.129,10.624,3.129C11.867,3.129,12.874,4.136,12.874,5.379C12.874,5.793,12.539,6.129,12.124,6.129C11.71,6.129,11.374,5.793,11.374,5.379C11.374,4.964,11.039,4.629,10.624,4.629C10.21,4.629,9.874,4.293,9.874,3.879Z" />
              </svg>
              <span>400-089-1870</span>
            </div>
            <div class="footer-connection-item">
              <svg class="icon-email" viewBox="0 0 18 13.5" width="18" height="13.5" fill="currentColor">
                <path d="M2.25,0C1.007,0,0,1.007,0,2.25C0,2.25,0,11.25,0,11.25C0,12.493,1.007,13.5,2.25,13.5C2.25,13.5,15.75,13.5,15.75,13.5C16.993,13.5,18,12.493,18,11.25C18,11.25,18,2.25,18,2.25C18,1.007,16.993,0,15.75,0C15.75,0,2.25,0,2.25,0ZM1.5,2.651C1.5,2.651,7.752,6.819,7.752,6.819C8.508,7.323,9.492,7.323,10.248,6.819C10.248,6.819,16.5,2.651,16.5,2.651C16.5,2.651,16.5,11.25,16.5,11.25C16.5,11.664,16.164,12,15.75,12C15.75,12,2.25,12,2.25,12C1.836,12,1.5,11.664,1.5,11.25C1.5,11.25,1.5,2.651,1.5,2.651ZM15.523,1.5C15.523,1.5,9.416,5.571,9.416,5.571C9.164,5.739,8.836,5.739,8.584,5.571C8.584,5.571,2.477,1.5,2.477,1.5C2.477,1.5,15.523,1.5,15.523,1.5Z" />
              </svg>
              <span>support@kylinos.cn</span>
            </div>
          </div>
        </div>
        <div class="footer-link-outer">
          <ul class="icon-list">
            <li class="icon-item">
              <div class="icon-wrap">
                <img src="@/assets/imgs/7.png" alt="微信" />
                <div class="qr-popup">
                  <img src="https://www.kylinos.cn/nuxt-resource/jpg/gzh.jpg" alt="微信公众号" />
                  <p>微信公众号</p>
                </div>
              </div>
            </li>
            <li class="icon-item">
              <a href="https://weibo.com/u/1980923093" target="_blank">
                <img src="@/assets/imgs/4.png" alt="微博" />
              </a>
            </li>
            <li class="icon-item">
              <div class="icon-wrap">
                <img src="@/assets/imgs/3.png" alt="视频号" />
                <div class="qr-popup">
                  <img src="https://www.kylinos.cn/nuxt-resource/jpg/sph.jpg" alt="视频号" />
                  <p>视频号</p>
                </div>
              </div>
            </li>
            <li class="icon-item">
              <div class="icon-wrap">
                <img src="@/assets/imgs/2.png" alt="抖音" />
                <div class="qr-popup">
                  <img src="https://www.kylinos.cn/nuxt-resource/jpg/dy.jpg" alt="抖音" />
                  <p>抖音</p>
                </div>
              </div>
            </li>
            <li class="icon-item">
              <a href="https://space.bilibili.com/2055926626?spm_id_from=333.337.0.0" target="_blank">
                <img src="@/assets/imgs/1.png" alt="bilibili" />
              </a>
            </li>
            <li class="icon-item">
              <a href="https://www.toutiao.com/c/user/token/MS4wLjABAAAAUK0iv1VxzS42927qq8QG2kZ9d2V7kfe84U5tod9pFZc/?" target="_blank">
                <img src="@/assets/imgs/6.png" alt="今日头条" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <hr class="footer-devided" />
      <div class="footer-bottom">
        <div class="bottom-copyright">
          <p class="copyright-text">版权所有 麒麟软件有限公司 Copyright 2020.kylinos.cn.All Rights Reserved. 网站备案号：<a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">津ICP备15002470号-1</a></p>
          <div class="footer-links">
            <a :href="circlePrivacy" target="_blank">隐私协议</a>
            <span class="sep">|</span>
            <a :href="circleLaw" target="_blank">法律声明</a>
            <span class="sep">|</span>
            <a :href="circleConduct" target="_blank">行为守则</a>
          </div>
        </div>
        <div class="bottom-selector" @mouseenter="friendLinkOpen = true" @mouseleave="friendLinkOpen = false">
          <div class="bottom-selector-main">
            <span>友情链接</span>
            <svg class="selector-icon" viewBox="0 0 1024 1024" width="12" height="8" fill="currentColor"><path d="M511.5 789.9 80.6 359c-22.8-22.8-22.8-59.8 0-82.6 22.8-22.8 59.8-22.8 82.6 0l348.3 348.3 348.3-348.3c22.8-22.8 59.8-22.8 82.6 0 22.8 22.8 22.8 59.8 0 82.6L511.5 789.9z"/></svg>
          </div>
          <transition name="friend-link-slide">
            <div class="bottom-link-list" v-show="friendLinkOpen">
              <a class="bottom-link-item" href="https://www.css.com.cn/css" target="_blank">中国软件</a>
              <a class="bottom-link-item" href="https://www.cs2c.com.cn/" target="_blank">中标软件</a>
              <a class="bottom-link-item" href="https://www.aosic.cn/" target="_blank">先进操作系统创新中心</a>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {config} from "@/units/request";

export default {
  name: 'Footer',
  data(){
    return {
      circlePrivacy: config.baseUrl + 'v1/page/getPageInfoByCode/CIRCLE_PRIVACY',
      circleLaw: config.baseUrl + 'v1/page/getPageInfoByCode/CIRCLE_LAW',
      circleConduct: config.baseUrl + 'v1/page/getPageInfoByCode/CIRCLE_CONDUCT',
      friendLinkOpen: false,
    }
  }
}
</script>

<style scoped lang="less">
.ky-footer {
  width: 100%;
  background-color: #FFFFFF;
  color: #707070;
  font-size: 12px;
  padding: 50px 80px 15px;
  box-sizing: border-box;
  font-family: "Source Han Sans CN", "思源黑体", "Noto Sans SC", system-ui, sans-serif;

  .footer-inner {
    max-width: 1200px;
    margin: 0 auto;
  }

  .footer-top {
    display: flex;
    align-items: flex-start;
  }

  .footer-logo {
    margin-right: 60px;
    flex-shrink: 0;

    img {
      height: 44px;
      display: block;
    }
  }

  .footer-main {
    flex: 1;
  }

  .direct-links {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    list-style: none;
    padding: 0;
    margin: 0;

    .direct-links-item {
      margin-right: 24px;
      white-space: nowrap;

      &:last-child {
        margin-right: 0;
      }

      a {
        color: #707070;
        text-decoration: none;
        font-size: 12px;

        &:hover {
          opacity: 0.7;
        }
      }
    }
  }

  .connection-list {
    display: flex;
    align-items: center;
    margin-top: 24px;
  }

  .footer-connection-item {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #707070;
    line-height: 21px;
    margin-right: 32px;

    &:last-child {
      margin-right: 0;
    }

    .icon-phone,
    .icon-email {
      margin-right: 8px;
      fill: #707070;
      flex-shrink: 0;
    }
  }

  .footer-link-outer {
    flex-shrink: 0;
    margin-left: 40px;
  }

  .icon-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
    gap: 16px;

    .icon-item {
      position: relative;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;

      .icon-wrap,
      a {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      img {
        width: 36px;
        height: 36px;
        display: block;
      }

      .qr-popup {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 10px;
        padding: 10px;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s, visibility 0.2s;
        text-align: center;
        white-space: nowrap;
        z-index: 10;

        img {
          width: 140px;
          height: 140px;
          display: block;
        }

        p {
          margin: 8px 0 0 0;
          font-size: 12px;
          color: #707070;
        }

        &::after {
          content: '';
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          border: 6px solid transparent;
          border-top-color: #FFFFFF;
        }
      }

      &:hover .qr-popup {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  .footer-devided {
    border: none;
    border-top: 1px solid #E0E0E0;
    margin: 30px 0 15px;
  }

  .footer-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .bottom-copyright {
      .copyright-text {
        margin: 0;
        font-size: 12px;
        color: #707070;
        line-height: 20px;

        a {
          color: #707070;
          text-decoration: none;

          &:hover {
            opacity: 0.7;
          }
        }
      }

      .footer-links {
        margin-top: 6px;
        font-size: 12px;

        a {
          color: #707070;
          text-decoration: none;

          &:hover {
            opacity: 0.7;
          }
        }

        .sep {
          margin: 0 8px;
          color: #CCCCCC;
        }
      }
    }

    .bottom-selector {
      position: relative;

      .bottom-selector-main {
        border-radius: 4px;
        border: 1px solid #E0E0E0;
        padding: 6px 16px 6px 18px;
        display: flex;
        align-items: center;
        cursor: pointer;

        span {
          font-size: 12px;
          line-height: 1;
          color: #707070;
        }

        .selector-icon {
          margin-left: 8px;
          fill: #707070;
        }
      }

      .bottom-link-list {
        position: absolute;
        bottom: 100%;
        right: 0;
        width: 100%;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        overflow: hidden;
        z-index: 10;

        .bottom-link-item {
          display: block;
          padding: 8px 16px;
          font-size: 12px;
          color: #707070;
          text-decoration: none;
          white-space: nowrap;
          text-align: center;

          &:hover {
            background-color: #F8F8F8;
            opacity: 0.8;
          }
        }
      }
    }
  }
}

.friend-link-slide-enter-active,
.friend-link-slide-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.friend-link-slide-enter,
.friend-link-slide-leave-to {
  opacity: 0;
  transform: translateY(5px);
}

@media (max-width: 1279px) {
  .ky-footer {
    padding: 50px 25px 15px;
    font-size: 12px;

    .footer-top {
      flex-direction: column;
      align-items: center;
    }

    .footer-logo {
      margin-right: 0;
      margin-bottom: 0;

      img {
        height: 40px;
      }
    }

    .footer-main {
      width: 100%;
    }

    .direct-links {
      justify-content: center;
      margin-top: 25px;

      .direct-links-item {
        margin: 6px 12px;
        margin-right: 12px;

        &:last-child {
          margin-right: 12px;
        }

        a {
          font-size: 12px;
        }
      }
    }

    .connection-list {
      flex-direction: column;
      align-items: center;
      margin-top: 20px;
    }

    .footer-connection-item {
      margin-right: 0;
      margin-bottom: 10px;
      font-size: 15px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .footer-link-outer {
      margin-top: 20px;
      margin-left: 0;
    }

    .icon-list {
      gap: 12px;
      justify-content: center;

      .icon-item {
        width: 32px;
        height: 32px;

        img {
          width: 32px;
          height: 32px;
        }
      }
    }

    .footer-devided {
      margin: 25px 0 15px;
    }

    .footer-bottom {
      flex-direction: column;
      align-items: center;

      .bottom-copyright {
        text-align: center;

        .copyright-text {
          font-size: 12px;
          line-height: 20px;
        }

        .footer-links {
          margin-top: 6px;
          font-size: 12px;
          text-align: center;
        }
      }

      .bottom-selector {
        margin-top: 15px;

        .bottom-selector-main {
          padding: 6px 14px;

          span {
            font-size: 12px;
          }
        }

        .bottom-link-list {
          .bottom-link-item {
            font-size: 12px;
            padding: 6px 10px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .ky-footer {
    padding: 30px 15px 15px;

    .footer-logo img {
      height: 32px;
    }

    .direct-links {
      .direct-links-item {
        margin: 4px 8px;
        margin-right: 8px;

        &:last-child {
          margin-right: 8px;
        }
      }
    }

    .icon-list {
      gap: 8px;

      .icon-item {
        width: 28px;
        height: 28px;

        img {
          width: 28px;
          height: 28px;
        }
      }
    }

    .footer-bottom {
      .copyright-text {
        font-size: 11px;
        line-height: 18px;
      }
    }
  }
}
</style>
